import React, { Component } from 'react'

export default class FAQ extends Component {
  render() {
    return (
        <main id="maincontent" className="page-main-pal container">
  <div className="page messages">
    <div data-placeholder="messages" />
    <div data-bind="scope: 'messages'">
      {/* ko if: cookieMessages && cookieMessages.length > 0 */}
      {/* /ko */}
      {/* ko if: messages().messages && messages().messages.length > 0 */}
      {/* /ko */}
    </div>
  </div>
  <div className="alocolumns clearfix">
    <div className="column main">
      <input name="form_key" type="hidden" defaultValue="e8QSSxcvECwAqRTn" />
      <div id="authenticationPopup" data-bind="scope:'authenticationPopup', style: {display: 'none'}" style={{display: 'none'}}>
        {/* ko template: getTemplate() */}
        {/* /ko */}
      </div>
      <div className="page-title">
        <h1>Contact Customer Service</h1>
      </div>
      <p style={{display: 'inline !important'}}>
        <strong>PHONE: 021-658-38222 (ID)</strong>
      </p>
      <p style={{display: 'inline !important'}}>
        <strong>WHATSAPP: +62811-9008-7895 </strong>
      </p>
      <p>
        <strong>EMAIL: </strong>
        <a href="mailto:info@kurniateknologi.com?subject=Customer%20Service%20query" title="Customer Service query">
          <strong>info@kurniateknologi.com</strong>
        </a>
      </p>
      <p>
        <strong>Customer Service Hours:</strong>
      </p>
      <p>
        <strong>Monday - Friday <br /> 8:30 a.m. - 5:00 p.m. WIB </strong>
      </p>
      <p>
        <strong>&nbsp;</strong>
        <strong>www.ZOLL.co.id</strong>
      </p>
      <p>&nbsp;</p>
    </div>
  </div>
</main>

    )
  }
}
